import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Accordion } from "react-bootstrap";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { store } from "../Redux/API";
import "./Careers.css";
import { showRegister } from "../Redux/HomeSlice";
import Register from "../Register/Register";
import Loader from "../Loader";
import Searsh from '../Searsh/Searsh'

import { faHeart } from "@fortawesome/free-solid-svg-icons";

const Careers = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(store());
  }, [dispatch]);

  const [activeTab, setActiveTab] = useState(0);

    // الأسئلة الشائعة
    const faqData = [
      { question: t('faq.question1'), answer: t('faq.answer1') },
      { question: t('faq.question2'), answer: t('faq.answer2') },
      { question: t('faq.question3'), answer: t('faq.answer3') },
      { question: t('faq.question4'), answer: t('faq.answer4') },
      { question: t('faq.question5'), answer: t('faq.answer5') },
      { question: t('faq.question6'), answer: t('faq.answer6') },
      { question: t('faq.question7'), answer: t('faq.answer7') },
      { question: t('faq.question8'), answer: t('faq.answer8') },
      { question: t('faq.question9'), answer: t('faq.answer9') },
      { question: t('faq.question10'), answer: t('faq.answer10') },
      { question: t('faq.question11'), answer: t('faq.answer11') }
    ];
  
  // بيانات التابات
  const tabs = [
    { label: <h5>{t('faqt.label')}</h5>, content: (
      <Accordion defaultActiveKey="0">
        {faqData.map((item, idx) => (
          <Accordion.Item eventKey={idx.toString()} key={idx}>
            <Accordion.Header>{item.question}</Accordion.Header>
            <Accordion.Body>{item.answer}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    )},
    { 
      label: <h5>{t('deliveryPolicy.label')}</h5> , 
      content: (
        <div className="delivery-policy-cards">
      <h5>{t('deliveryPolicy.content.title')}</h5>
      <p>{t('deliveryPolicy.content.description')}</p>

      {/* البطاقة الأولى */}
      <div className="delivery-card">
        <h6>{t('deliveryPolicy.content.cards.1.title')}</h6>
        <p>{t('deliveryPolicy.content.cards.1.description')}</p>
        <p>{t('deliveryPolicy.content.cards.1.missingInfo')}</p>
      </div>

      {/* البطاقة الثانية */}
      <div className="delivery-card">
        <h6>{t('deliveryPolicy.content.cards.2.title')}</h6>
        <p><strong>{t('deliveryPolicy.content.cards.2.shippingCost')}</strong></p>
        <p><strong>{t('deliveryPolicy.content.cards.2.deliveryTime')}</strong></p>
        <ul>
          <li>{t('deliveryPolicy.content.cards.2.details.kuwait')}</li>
          <li>{t('deliveryPolicy.content.cards.2.details.uae')}</li>
          <li>{t('deliveryPolicy.content.cards.2.details.bahrain')}</li>
          <li>{t('deliveryPolicy.content.cards.2.details.qatar')}</li>
          <li>{t('deliveryPolicy.content.cards.2.details.oman')}</li>
        </ul>
      </div>

      {/* البطاقة الثالثة */}
      <div className="delivery-card">
        <h6>{t('deliveryPolicy.content.cards.3.title')}</h6>
        <ul>
          <li>{t('deliveryPolicy.content.cards.3.cities.riyadh')}</li>
          <li>{t('deliveryPolicy.content.cards.3.cities.jeddah')}</li>
          <li>{t('deliveryPolicy.content.cards.3.cities.otherCities')}</li>
        </ul>
        <p>{t('deliveryPolicy.content.cards.3.note')}</p>
      </div>
    </div>
      )
    },
    { 
      label: <h5>{t('termsConditions.label')}</h5>, 
      content: (
        <div className="terms-and-conditions">
        <h5>{t("termsAndConditions.title")}</h5>
        <p>{t("termsAndConditions.intro")}</p>
        
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.platform.title")}</h6>
          <p>{t("termsAndConditions.sections.platform.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.admin.title")}</h6>
          <p>{t("termsAndConditions.sections.admin.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.customer.title")}</h6>
          <p>{t("termsAndConditions.sections.customer.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.account.title")}</h6>
          <p>{t("termsAndConditions.sections.account.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.store.title")}</h6>
          <p>{t("termsAndConditions.sections.store.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.agreement.title")}</h6>
          <p>{t("termsAndConditions.sections.agreement.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.pricing.title")}</h6>
          <p>{t("termsAndConditions.sections.pricing.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.purchases.title")}</h6>
          <p>{t("termsAndConditions.sections.purchases.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.suppliersAndCustomers.title")}</h6>
          <p>{t("termsAndConditions.sections.suppliersAndCustomers.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.contentResponsibility.title")}</h6>
          <p>{t("termsAndConditions.sections.contentResponsibility.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.ownership.title")}</h6>
          <p>{t("termsAndConditions.sections.ownership.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.refunds.title")}</h6>
          <p>{t("termsAndConditions.sections.refunds.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.changes.title")}</h6>
          <p>{t("termsAndConditions.sections.changes.content")}</p>
        </div>
  
        <div className="terms-card">
          <h6>{t("termsAndConditions.sections.contactUs.title")}</h6>
          <p>{t("termsAndConditions.sections.contactUs.content")}</p>
        </div>
        <div className="terms-card">
          <p>{t("termsAndConditions.sections.contac.content")}</p>
        </div>
  
        <p className="m-auto text-center">{t("termsAndConditions.sections.lastUpdate")}</p>
      </div>
      )
    },    { 
      




      label: <h5>{t('returnPolicy.label')}</h5>, 
      content: (
      <div className="return-policy-cards">
      <h5>{t('returnPolicy.label')}</h5>
      <div className="return-card">

      <h6>{t('returnPolicy.generalTerms.title')}</h6>
      <ul>
        <li>{t('returnPolicy.generalTerms.item1')}</li>
        <li>{t('returnPolicy.generalTerms.item2')}</li>
        <li>{t('returnPolicy.generalTerms.item3')}</li>
      </ul>
      </div>
      <div className="return-card">

      <h6>{t('returnPolicy.nonReturnableItems.title')}</h6>
      <ul>
        <li>{t('returnPolicy.nonReturnableItems.item1')}</li>
        <li>{t('returnPolicy.nonReturnableItems.item2')}</li>
        <li>{t('returnPolicy.nonReturnableItems.item3')}</li>
      </ul>
      </div>
      <div className="return-card">

      <h6>{t('returnPolicy.returnProcess.title')}</h6>
      <p>{t('returnPolicy.returnProcess.description')}</p>
      <ul>
        <li>{t('returnPolicy.returnProcess.step1')}</li>
        <li>{t('returnPolicy.returnProcess.step2')}</li>
      </ul>
      </div>

      <div className="return-card">

      <h6>{t('returnPolicy.contactUs.title')}</h6>
      <p>{t('returnPolicy.contactUs.description')}</p>
      <p>{t('returnPolicy.contactUs.phone')}</p>
      <p>{t('returnPolicy.contactUs.email')}</p>
      <p>{t('returnPolicy.contactUs.address')}</p>
      </div>
    </div>
      )
    },
  ];

  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  const showR = useSelector((state) => state?.products?.showR);

  const Sign_Up = (event) => {
    if (!token) {
      const { pageY } = event;
      const offsetY = -1200;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true));
    }
  };

  const show_searsh = useSelector((state) => state?.products?.searsh);
  return (
    <div className="About">
      <Header />


      {showR && (
        <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}

      {show_searsh && (
        <Searsh />
      )}

      <div className="tabs-container container g-0">
        {/* <h4>مرحبًا بكم في موقعنا</h4> */}
        
        <div className="tabs-header">
          {tabs.map((tab, index) => (
            <p
              key={index}
              className={`tab-button ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {tab.label}
            </p>
          ))}
        </div>

        {/* محتوى التاب النشط */}
        <div className="tab-content">
          {tabs[activeTab].content}
        </div>
      </div>
      <Footer Sign_Up={Sign_Up} />
    </div>
  );
};

export default Careers;